import React, { useState } from 'react'
import { auth } from '../Config/firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import './Registration.scss'
import { useNavigate } from 'react-router-dom';

const inetialstate = {

    email: '',
    password: ''

}


export default function Register() {

    const navigate=useNavigate()
    const [state, setState] = useState(inetialstate);
    const [processing, setProcessing] = useState(false)


    const handleChange = (e) => {

        const { name, value } = e.target

        setState(s => ({ ...s, [name]: value }))

    }





    const handleSubmit = (e) => {

        e.preventDefault()

       
        let { email, password } = state;

        if (password.length < 6) {
            return alert('password should be atleaset 6 characters long')
        }

        console.log(email, password)
        setProcessing(true)
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                // Signed in 
                const user = userCredential.user;
                console.log(user)
                alert('user signup completed')
                setState(inetialstate)
                navigate('/')
                // ...
            })
            .catch((error) => {
                console.log(error)
                // const errorCode = error.code;
                // const errorMessage = error.message;
                alert('something went wrong')
                // ..
            }).finally(() => {
                setState(inetialstate)
                setProcessing(false)
            });



    }

    return (
        <div className="signup-card">
            <h2>Sign Up</h2>
            <form onSubmit={handleSubmit}>
                <label >Email</label>
                <input type="email" id="email" name="email" value={state.email} required onChange={handleChange} />
                <label >Password</label>
                <input type="password" id="password" name="password" value={state.password} required onChange={handleChange} />
               
                <button type="submit" >{

                    !processing ? <span>Sign Up</span> : <div className="spinner spinner-glow spinner-sm"></div>

                }</button>
            </form>
            <p>You don't have Account? <button className='signe-btn'>Signe Up</button> </p>
        </div>

    )


}

